import React from 'react';
import { View } from 'react-native';
import { LABEL_HEIGHT, PositionedLabel } from './Label';
import { RunningSumLineChart, useChartWidth } from './Charts';
import { makeLineChartData } from './types';
const HorizontalAxisLabels = React.memo(() => {
    // There are 32 data points, [0, 32). Labels are 1, 6, 11, 16, 21, 26, 31.
    const labels = [];
    for (let date = 1; date <= 31; date += 5) {
        labels.push(date);
    }
    const width = useChartWidth();
    return (<View style={styles.container}>
      {labels.map((date) => (<PositionedLabel key={date} text={date.toString()} position={date / 31} containerWidth={width}/>))}
    </View>);
});
const MonthlyChart = ({ previous, previousColor, current, currentColor, currency, }) => (<>
    <RunningSumLineChart previous={previous ? makeLineChartData(previous, previousColor) : undefined} current={makeLineChartData(current, currentColor)} currency={currency}/>
    <HorizontalAxisLabels />
  </>);
const styles = {
    container: {
        justifyContent: 'center',
        height: LABEL_HEIGHT,
    },
};
export default MonthlyChart;
